<template>
  <div class="budget-box">
    <el-card class="box-card" header='项目预算'>

      <el-table :data="feeItemList" style="width: 100%" height="500" show-overflow-tooltip='true'>
        <el-table-column prop="index" label="序号" width="50" header-align='center' fixed></el-table-column>
        <el-table-column prop="itemName" class-name='item-name' label="项目明细名称" width="180" header-align='center'>
          <template slot-scope="scope">
            <!-- <el-button type="text" size="small" icon="el-icon-circle-plus-outline" v-if="scope.$index===feeItemList.length-1 && !scope.row.itemId" @click="addDialogVisible = true">添加明细</el-button> -->
            <span>{{scope.row.name}}</span>
            <el-tooltip v-if="scope.row.desc" class="item" effect="dark" :content="scope.row.desc" placement="right">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="unit" label="计量单位" width="80" header-align='center'>
        </el-table-column>

        <el-table-column label="申报" header-align='center'>
          <el-table-column prop="count" label="数量" width="80" header-align='center'>
            <template slot-scope="scope" >
              <el-input v-if="scope.row.level==2 && !disabled" v-model="scope.row.count" @change='calc(scope.row)'></el-input>
              <span v-if="disabled">{{scope.row.count}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="单价" width="80" header-align='center'>
            <template slot-scope="scope" >
              <el-input v-if="scope.row.level==2 && !disabled" v-model="scope.row.price" @change='calc(scope.row)'></el-input>
              <span v-if="disabled">{{scope.row.price}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="days" label="天数" width="80" header-align='center'>
            <template slot-scope="scope" >
              <el-input v-if="scope.row.level==2 && !disabled" v-model="scope.row.days" @change='calc(scope.row)'></el-input>
              <span v-if="disabled">{{scope.row.days}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="fee" label="金额" width="80" header-align='center'>
            <template slot-scope="scope" >
              <el-input v-if="scope.row.level==2 && !disabled" v-model="scope.row.fee" @change='calc(scope.row)'></el-input>
              <span v-if="disabled">{{scope.row.fee}}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column prop="remark" label="备注（详细填写）">
          <template slot-scope="scope" >
            <el-input v-if="scope.row.level==2 && !disabled" v-model="scope.row.remark" @change='calc(scope.row)'></el-input>
            <span v-if="disabled">{{scope.row.remark}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" width="200">
          <template slot-scope="scope" v-if="!disabled">
            <span v-if="scope.row.level>1 && scope.$index!=feeItemList.length-1">
              <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row)">编辑</el-button>
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeById(scope.row.itemId)">删除</el-button>
            </span>
          </template>
        </el-table-column> -->
      </el-table>

      <!-- <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addDialogVisible = true">添加明细</el-button> -->
      <div class="total-box">
        <div class="title">项目合计</div>
        <div class="items">
          <div class="fee">
            <div class="fee-value">{{(detail.totalCost/100).toLocaleString()}}</div>
            <div class="fee-name">收入总计</div>
          </div>
          <div class="fee">
            <div class="fee-value">{{(total).toLocaleString()}}</div>
            <div class="fee-name">支出总计</div>
          </div>
          <div class="fee">
            <div class="fee-value">{{rate}}</div>
            <div class="fee-name">利润率</div>
          </div>
        </div>
      </div>

      <div class="remark-title">备注信息</div>
      <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 4}" placeholder="请在下方输入内容" v-model="detail.remark" :disabled='disabled'>
      </el-input>

    </el-card>
    <!-- 添加权限的对话框 -->
    <el-dialog title="添加项目预算" :visible.sync="addDialogVisible" width="50%" :close-on-click-modal='false'>
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="formRules" ref="addFormRef" label-width="100px" label-position="right">
        <el-row :gutter="20">
          <el-col :span='12'>
            <el-form-item label="费用明细" prop="itemNames">
              <el-cascader v-model="addForm.itemNames" :options="filterOptions" @change="selectItem"></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label="计量单位" prop="unit">
              <el-input v-model="addForm.unit"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span='12'>
            <el-form-item label="数量" prop="count">
              <el-input v-model.number="addForm.count"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label="单价" prop="price">
              <el-input v-model.number="addForm.price"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span='12'>
            <el-form-item label="天数" prop="days">
              <el-input v-model.number="addForm.days"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label="金额" prop="showFee">
              <el-input v-model.number="addForm.showFee"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="addForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addDetail">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as enumApi from '../../api/enumAPI'
import * as projectApi from '../../api/projectAPI'
export default {
  name: 'budget',
  components: {

  },
  props: {
    project: {
      type: Object,
      default: function () {
        return {}
      }
    },
    detail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      feeList: [],
      addForm: {
        itemNames: []
      },
      formRules: {
        // itemNames: [{ required: true, message: "请选择费用项", trigger: "change", },],
        count: [{ type: 'number', message: '数量必须为数字值' }],
        price: [{ type: 'number', message: '单价必须为数字值' }],
        days: [{ type: 'number', message: '天数必须为数字值' }],
        fee: [{ required: true, type: 'number', message: '金额必须为数字值' }],
      },
      addDialogVisible: false,
      options: [],
      feeMap: {},
      model: 'add',
      projectId: '',
      enumList: []
    };
  },
  computed: {
    total() {
      return this.feeList.reduce((pre, curr) => pre + (curr.fee || 0), 0) / 100
    },
    rate() {
      return ((this.detail.totalCost / 100 - this.total) / (this.detail.totalCost / 100) * 100).toFixed(2) + "%"
    },
    filterOptions() {
      let ids = this.feeList.map(fee => fee.itemId)
      return this.enumList.filter(e => e.level == 1).map(o => {
        let p = { ...o }
        p.label = p.name
        p.children = this.enumList.filter(c => c.pid == p.id && (!ids.includes(c.id + '') || this.model == 'update')).map(en => {
          let c = { ...en }
          c.label = c.name;
          return c
        })
        return p
      })
    },
    /*  feeItemList() {
       let ids = this.feeList.map(d => d.itemId+'')
       let childs = this.enumList.filter(e => ids.includes(e.id + ''))
       let pids = new Set(childs.map(e => e.pid))
       let feeList = this.feeList.map(f => {
         let find = childs.find(c => c.id == f.itemId)
         return { ...find, ...f }
       })
       let feeItemList = []
       pids.forEach(pid => {
         let p = this.enumList.find(e => e.id == pid)
         //this.feeList.push(p)
         console.log('pid', p);
         p.index = p.value
         let child = feeList.filter(f => f.pid == pid).map((f, index) => { f.index = index + 1; return f })
         console.log('child', child);
         feeItemList = [...feeItemList, p, ...child]
       })
       if(!this.disabled){
         feeItemList.push({})
       }
       console.log("parents", childs, ids);
       return feeItemList
     } */

    feeItemList() {

      let feeItemList = []
      let parents = this.enumList.filter(e => e.pid == 0)
      parents.forEach(p => {
        let child = this.enumList.filter(e => e.pid == p.id)
        p.index = p.value
        child = child.map((c, index) => {
          c.index = index + 1
          c.unit = '元'
          let find = this.feeList.find(f => c.id == f.itemId)
          let remark = ''
          if (find) {
            find = { ...find }
            find.feeId = find.id
            find.fee = find.fee / 100
            remark = find.remark
          }
          return { ...find, ...c,remark}

        })
        feeItemList = [...feeItemList, p, ...child]
      });
      return feeItemList
    }
  },
  watch: {

  },
  async created() {
    let res = await enumApi.list({ type: 'fee-item' })
    if (res.flag) {
      this.enumList = Array.from(res.data)
      console.log(res.data)

    }
  },
  async mounted() {
    this.projectId = this.$route.params.id
    await this.qryFeeList()
  },
  methods: {
    async qryFeeList() {
      let res = await projectApi.qryProjectFee(this.projectId)
      if (res.flag) {
        this.feeList = res.data
      }
    },
    async addDetail() {
      await this.validate()
      console.log("addDetail", this.addForm);
      let form = { ...this.addForm }
      form.fee = form.showFee * 100
      if (this.model == 'update') {//修改
        this.feeList = this.feeList.map(f => {
          if (f.itemId == form.itemId) {

            return { ...f, ...form }
          }
          return f
        });
        console.log(this.feeList);
      } else {//新增       
        this.feeList.push(form)
      }

      this.initForm()
    },
    selectItem(arr) {
      console.log("selectItem", arr);
      if (!arr || !arr.length) return
      let parentId = arr[0]
      let childId = arr[1]
      let find = this.feeList.filter(fee => fee.id == childId)
      if (find.length) {
        this.addForm.itemNames = []
        this.$message.error("不允许添加重复费用项")
        return
      }
      let parent = this.enumList.find(o => o.value == parentId)
      let child = this.enumList.find(c => c.value == childId)
      // this.addForm.value = child.value
      this.addForm.pid = parent.id
      this.addForm.itemId = child.id
      this.addForm.itemName = child.name


    },
    calc(item) { 
      if(item.count&&item.days&&item.price){
        let  fee = item.count*item.days*item.price
        this.$set(item,'fee',fee)
      }
      let find = this.feeList.find(i =>i.itemId == item.id)
        if(find){
          find.count = item.count
          find.days = item.days
          find.price = item.price
          find.fee = item.fee?item.fee*100:0
          find.remark = item.remark
        }else{
          this.feeList = [...this.feeList,{...item,itemId:item.id,itemName:item.name,fee:'',remark:''} ]
        }
      console.log('calc',item);
    },
    showEditDialog(item) {
      console.log('showEditDialog', item);
      this.addForm = { ...item }
      this.addForm.showFee = item.fee / 100
      this.addForm.itemNames = [this.enumList.find(e => e.id == item.pid).value, item.value]
      this.model = 'update'
      this.addDialogVisible = true
    },
    initForm() {
      this.addDialogVisible = false
      this.addForm = {}
      this.model = 'add'
    },
    async validate() {
      let flag = true
      await this.$refs.addFormRef.validate(async (valid, rules) => {
        if (!valid) {
          for (const key in rules) {
            flag = false;
            console.log(key, rules[key][0].message)
            this.$message.error(rules[key][0].message)
            throw Error(rules[key][0].message)
          }
          return
        }
      })
      if (!flag) {
        throw Error('校验失败')
      }
    },
    removeById(id) {
      this.feeList = this.feeList.filter(f => f.itemId != id)
    },

  },
};
</script>

<style  lang="less">
.budget-box {
  .el-card {
    border: none;
    box-shadow: none;
    border-radius: 0;
    padding-bottom: 20px;
    .el-card__header {
      padding: 20px 0;
      margin: 0 40px;
      padding-left: 20px;
      position: relative;
      &::before {
        position: absolute;
        content: "";
        width: 4px;
        height: 20px;
        background: #346aff;
        opacity: 1;
        display: block;
        left: 0px;
        top: 20px;
      }
    }
    .el-card__body {
      padding: 0 40px;
      .el-table {
        font-size: 14px;
        .el-table__cell {
          padding: 5px 0;
        }
        th {
          color: #3c4353;
          background: #ebf0ff;
          // font-size: 15px;
          // font-weight: normal;
          border-color: #dee7ff;
        }
        tbody {
          font-size: 12px;
          button {
            margin-top: 0;
            font-size: 14px;
          }
          .item-name {
            .cell {
              display: flex;
              justify-content: space-between;
              align-items: center;
              .el-icon-question {
                color: #dcdcdc;
              }
            }
          }
        }
        .el-input__inner {
          height: 30px;
          padding: 0;
          text-align: center;
        }
      }
    }
    .total-box {
      background: #f5f7ff;
      padding: 20px;
      margin-top: 20px;
      border: 1px solid #dee7ff;
      color: #3c4353;
      .title {
        font-size: 16px;
      }
      .items {
        display: flex;
        margin-top: 20px;
        .fee {
          flex: 1;
          padding: 20px 60px;
          background: #a3baf3;
          border-radius: 5px;
          .fee-value {
            font-size: 20px;
          }
          .fee-name {
            margin-top: 10px;
            font-size: 15px;
            opacity: 0.5;
          }
        }
        .fee + .fee {
          margin-left: 20px;
        }
        .fee:nth-child(2) {
          background: #f6e1e1;
        }
        .fee:nth-child(3) {
          background: #d6f3ef;
        }
      }
    }
    .remark-title {
      color: #3c4353;
      margin: 20px 0;
    }
  }
  .el-dialog {
    .el-input__inner {
      min-width: 150px;
    }
  }
}
</style>
